import { CommentOutlined } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { size } from "lodash";

const CommentsIconButton = ({
  tooltip = "Show Comment",
  active,
  comments,
  onClick,
  showIfEmpty = false,
}) => {
  if (!showIfEmpty && size(comments) === 0) {
    return null;
  }
  return (
    <Tooltip title={tooltip}>
      <IconButton
        size="small"
        color={active ? "primary" : "initial"}
        onClick={onClick}
      >
        <Badge badgeContent={size(comments)} color="primary">
          <CommentOutlined className="thin" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default CommentsIconButton;
